import { render, staticRenderFns } from "./FeedNsfwNotice.vue?vue&type=template&id=5a1680a1&scoped=true&"
import script from "./FeedNsfwNotice.vue?vue&type=script&lang=ts&"
export * from "./FeedNsfwNotice.vue?vue&type=script&lang=ts&"
import style0 from "./FeedNsfwNotice.vue?vue&type=style&index=0&id=5a1680a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1680a1",
  null
  
)

export default component.exports